import { AffaireControl } from '../../../Models/Affaires/Affaires';
import { CompagnonDetails, ContractType, CompagnonRole } from '../../../Models/Compagnon/Compagnon';
import { BaseViewState } from '../../Base/BaseViewModel';

export enum ControlListTodayViewType {
    Veille = 'Veille',
    Today = 'Today',
}

export interface ControleListTodayViewState extends BaseViewState {
    date: Date;
    items: Array<AffaireControl>;
    compagnons: Array<CompagnonDetails>;
    conducteurTravauxSelected?: CompagnonDetails;
    busy: boolean;
    state: ControlListTodayViewType;
    from_day_date?: Date;
    to_day_date?: Date;
}

export const InitialControleListTodayViewState: ControleListTodayViewState = {
    date: new Date(),
    items: [],
    compagnons: [],
    busy: false,
    conducteurTravauxSelected: undefined,
    state: ControlListTodayViewType.Veille,
    from_day_date: (() => {
        const today = new Date();
        const dayOfWeek = today.getDay();
        const firstDayOfWeek = new Date(today);
        firstDayOfWeek.setDate(today.getDate() - dayOfWeek);
        return firstDayOfWeek;
    })(),
    to_day_date: new Date(new Date().setDate(new Date().getDate())),
};
